export const parseYouTubeStartSeconds = (rawValue) => {
  if (!rawValue) return null;
  if (/^\d+$/.test(rawValue)) {
    return Number(rawValue);
  }

  const match = rawValue.match(/^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/i);
  if (!match) return null;

  const hours = Number(match[1] || 0);
  const minutes = Number(match[2] || 0);
  const seconds = Number(match[3] || 0);
  const total = hours * 3600 + minutes * 60 + seconds;

  return total > 0 ? total : null;
};

export const toYouTubeEmbed = (url) => {
  if (!url) return null;

  try {
    const normalized = /^https?:\/\//i.test(url) ? url : `https://${url}`;
    const parsed = new URL(normalized);
    const host = parsed.hostname.toLowerCase().replace(/^www\./, '');

    let videoId = '';
    let playlistId = parsed.searchParams.get('list') || '';

    if (host === 'youtu.be') {
      videoId = parsed.pathname.split('/').filter(Boolean)[0] || '';
    } else if (host === 'youtube.com' || host === 'm.youtube.com' || host === 'youtube-nocookie.com') {
      const segments = parsed.pathname.split('/').filter(Boolean);
      if (parsed.pathname === '/watch') {
        videoId = parsed.searchParams.get('v') || '';
      } else if (segments[0] === 'embed' || segments[0] === 'shorts' || segments[0] === 'live') {
        videoId = segments[1] || '';
      } else if (segments[0] === 'playlist') {
        playlistId = playlistId || parsed.searchParams.get('list') || '';
      }
    }

    const params = new URLSearchParams();
    const startRaw = parsed.searchParams.get('t') || parsed.searchParams.get('start');
    const startSeconds = parseYouTubeStartSeconds(startRaw);
    if (startSeconds) {
      params.set('start', String(startSeconds));
    }

    if (videoId) {
      if (playlistId) {
        params.set('list', playlistId);
      }
      const query = params.toString();
      return `https://www.youtube.com/embed/${encodeURIComponent(videoId)}${query ? `?${query}` : ''}`;
    }

    if (playlistId) {
      params.set('list', playlistId);
      return `https://www.youtube.com/embed/videoseries?${params.toString()}`;
    }

    return null;
  } catch (_) {
    return null;
  }
};

export const toOdyseeEmbed = (url) => {
  if (!url) return null;

  try {
    const normalized = url.startsWith('lbry://') ? url.replace('lbry://', 'https://') : url;
    const parsed = new URL(normalized);
    const host = parsed.hostname.toLowerCase();
    const isOdysee = host.includes('odysee.com') || host.includes('lbry.tv');
    if (!isOdysee) return null;

    const segments = parsed.pathname.split('/').filter(Boolean);
    if (!segments.length) return null;

    const path = segments.map((segment) => decodeURIComponent(segment)).join('/');
    if (path.startsWith('$/embed')) {
      return `https://odysee.com/${path}`;
    }

    return `https://odysee.com/$/embed/${path}`;
  } catch (_) {
    return null;
  }
};

export const toEmbeddableMediaUrl = (url) => toYouTubeEmbed(url) || toOdyseeEmbed(url);
